var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymKumlokk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 2,
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 2,
    cx: 15,
    cy: 15,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 2.5)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 19.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 16.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 5.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 22.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 23.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 20.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 21.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 18.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 11.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 6.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 2.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.5,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymKumlokk);
export default __webpack_public_path__ + "static/media/BYM_Kumlokk.4a966cd8.svg";
export { ForwardRef as ReactComponent };